<template>
  <div>
    <div class="pa-3" style="display: flex; align-items: center">
      <h1>Dine-In Store Category Management</h1>
      <v-divider vertical class="mx-3 hidden-xs-only"></v-divider>
      <v-btn
        color="primary"
        style="color: black"
        @click="storeCategoryDialog = true"
        class="hidden-xs-only"
        ><v-icon color="black" class="pr-1">add</v-icon> More Category
      </v-btn>
      <v-btn
        class="hidden-sm-and-up"
        @click="storeCategoryDialog = true"
        color="primary"
        fab
        fixed
        style="bottom: 50px; right: 25px"
        ><v-icon size="28" color="black">add</v-icon>
      </v-btn>
    </div>
    <v-data-table
      style="border: 1px solid black"
      :headers="headers"
      :search="search"
      :loading="isLoadingData"
      :items="categoryList"
      :rows-per-page-items="[25, 50, 100]"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">
          <v-switch
            v-model="props.item.store_category_status"
            color="primary"
            @change="changeState(props.item)"
            hide-details
          ></v-switch>
        </td>
        <td style="display: flex; justify-content: center">
          <v-img
            style="max-width: 80px; max-height: 80px"
            :src="props.item.store_category_image"
          />
        </td>
        <td class="text-xs-center">
          {{ props.item.store_category_name_th }}
        </td>
        <td class="text-xs-center">
          {{ props.item.store_category_name_en }}
        </td>
        <td class="text-xs-center">
          <v-btn
            color="info"
            small
            fab
            class="view-detail-btn"
            @click="toEdit(props.item, props.index)"
          >
            <v-icon style="font-size: 18px; color: white">edit</v-icon>
          </v-btn>
          <v-btn
            color="error"
            small
            fab
            class="delete-btn"
            @click="toDelete(props.item)"
            :loading="isDeleteId.includes(props.item.store_category_id)"
          >
            <v-icon style="font-size: 18px; color: white">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <div
          v-if="dinein_store_list.length == 0 && isLoadingData != true"
          class="text-xs-center"
        >
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ isLoadingData == true ? "Loading data ..." : isLoadingData }}
        </div>
      </template>
    </v-data-table>

    <formStoreCategory
      @onClosed="
        selectedIndex = -1;
        storeCategoryDialog = false;
      "
      @onSubmit="submitForm($event)"
      :dialog="storeCategoryDialog"
      :editedIndex="selectedIndex"
      :selectedItem="selectedItem"
    />

    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card>
        <v-card-title class="headline red white--text" primary-title>
          Delete category
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Are you sure to permanent delete this category?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="deleteDialog = false"> Cancel </v-btn>
          <v-btn color="primary" flat @click="deleteStoreCategory()">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Failed
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Your deletion failed with some problems. Please try again.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_dialog = false"> Cancel </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="error_type_dialog" max-width="500px">
      <v-card>
        <v-card-title class="headline yellow lighten-2" primary-title>
          Delete Failed
        </v-card-title>

        <v-card-text style="font-size: 1.35rem; margin-block: 15px">
          Your deletion failed because this type still have stores that were in
          this type. Please check store again.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" flat @click="error_type_dialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import formStoreCategory from "@/components/back-office/DineIn/Store/formStoreCategory.vue";
export default {
  data: () => ({
    search: "",
    detail_dialog: false,
    dialog: false,
    isLoadingData: false,
    error_type_dialog: false,
    deleteDialog: false,
    edit_item: 0,
    delete_id: "",
    error_dialog: false,
    store_name_th: null,

    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Status",
        align: "center",
        value: "store_status",
        sortable: false,
      },
      {
        text: "Image",
        align: "center",
        value: "store_status",
        sortable: false,
      },
      {
        text: "Store Type Name TH",
        align: "center",
        value: "store_type_name_th",
        sortable: false,
      },
      {
        text: "Store Type Name EN",
        align: "center",
        value: "store_type_name_en",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
    storeCategoryDialog: false,
    selectedItem: {},
    selectedIndex: -1,
    isDeleteId: [],
  }),
  components: { formStoreCategory },
  computed: {
    ...mapState({
      dinein_store_list: (state) => state.fetchDineIn.store_list,
      provinceData: (state) => state.fetchProvinceBack.provinceData,
      categoryList: (state) => state.fetchDineIn.storeCategoryList,
    }),
    ...mapGetters(["isEditStoreApprove"]),
  },
  watch: {},

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions({
      fetchStoreCategory: "fetchDineIn/fetchStoreCategory",
      createStoreCategory: "fetchDineIn/createStoreCategory",
      updateStoreCategory: "fetchDineIn/updateStoreCategory",
      removeStoreCategory: "fetchDineIn/removeStoreCategory",
    }),
    moment,
    toEdit(item, index) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.storeCategoryDialog = true;
      this.selectedIndex = index;
    },
    toDelete(item) {
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.deleteDialog = true;
    },
    watchEditDialog() {
      this.storeCategoryDialog = false;
    },
    watchEditTimeDialog() {
      this.edit_store_time_dialog = false;
    },
    async deleteStoreCategory() {
      this.deleteDialog = false;
      let storeCategoryId = this.selectedItem.store_category_id;
      this.isDeleteId.push(storeCategoryId);
      var res = await this.removeStoreCategory(storeCategoryId);
      let index = this.isDeleteId.findIndex((val) => val == storeCategoryId);
      this.isDeleteId.splice(index, 1);
      if (res.msg === false) return;
    },
    async changeState(item) {
      var payload = {
        store_category_id: item.store_category_id,
        store_category_name_th: item.store_category_name_th,
        store_category_name_en: item.store_category_name_en,
        store_category_status: item.store_category_status,
      };
      var res = await this.updateStoreCategory(payload);
      if (res == false)
        item.store_category_status = !item.store_category_status;
    },
    getProvinceName(id) {
      let isFound = "";
      for (let i = 0; i < this.provinceData.length; i++) {
        if (this.provinceData[i].province_id == id) {
          isFound = this.provinceData[i].province_name_en;
        }
      }
      if (isFound != "") {
        return isFound;
      } else {
        return null;
      }
    },
    async fetchData() {
      this.isLoadingData = true;
      await this.fetchStoreCategory();
      this.isLoadingData = false;
    },
    async submitForm(e) {
      let result;
      if (this.selectedIndex == -1) {
        result = await this.createStoreCategory(e.form);
      } else {
        result = await this.updateStoreCategory(e.form);
      }
      e.done();

      if (result == false) return;
      this.selectedIndex = -1;
      this.storeCategoryDialog = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}

/* .view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
} */

.edit-time-btn {
  font-size: 13px;
  outline: none;
  background-color: #2175f3;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  margin-right: 10px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.delete-btn {
  font-size: 13px;
  outline: none;
  background-color: red;
  padding: 5px;
  border-radius: 20px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
